__turbopack_context__.v({
  "arrow": "MyRankPill-module-scss-module__0XdB8G__arrow",
  "divider": "MyRankPill-module-scss-module__0XdB8G__divider",
  "jump": "MyRankPill-module-scss-module__0XdB8G__jump",
  "label": "MyRankPill-module-scss-module__0XdB8G__label",
  "pill": "MyRankPill-module-scss-module__0XdB8G__pill",
  "pillUp": "MyRankPill-module-scss-module__0XdB8G__pillUp",
  "rank": "MyRankPill-module-scss-module__0XdB8G__rank",
  "unit": "MyRankPill-module-scss-module__0XdB8G__unit",
  "value": "MyRankPill-module-scss-module__0XdB8G__value",
  "visual": "MyRankPill-module-scss-module__0XdB8G__visual",
});
